export const projects = [
  {
    title: "HueMuse - In-Progress Project",
    description: "AI-powered color palette generator that analyzes work-in-progress artwork to suggest harmonious color palettes, or generates palettes from text prompts using machine learning",
    tech: ["React", "Python", "AI/ML", "Image Processing", "API Integration"],
    link: "#",
    github: "#"
  },
  {
    title: "Music Chatbot",
    description: "Built a chatbot with React frontend, Flask backend, and MongoDB database. Implemented a CYK-based NLP parser handling 5,000+ artist/genre queries with 150 ms latency",
    tech: ["React", "Flask", "MongoDB", "NLP", "Python"],
    link: "#",
  },
  {
    title: "Supreme Court Judgement Predictions - UCI ML Project",
    description: "LSTM model with integrated sentiment analysis that predicted Supreme Court judgements",
    tech: ["Machine Learning", "Python", " Text Classification", "Neural Networks"],
    link: "#",
  },
];